import React from "react";
import { CalendarClock } from "lucide-react";
import { parseDateOnly } from "@/lib/utils";

const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

// Green/amber/red days-until-due countdown chip. Handles null + far-future gracefully.
export function DueChip({ due, testid }) {
  const parsed = parseDateOnly(due);
  if (!parsed || isNaN(parsed)) {
    return (
      <span data-testid={testid} className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded border bg-zinc-100 text-zinc-500 border-zinc-200 whitespace-nowrap">
        <CalendarClock className="h-3 w-3" /> No due date
      </span>
    );
  }
  const today = startOfDay(new Date());
  const d0 = startOfDay(parsed);
  const days = Math.round((d0 - today) / 86400000);
  let cls = "bg-emerald-50 text-emerald-700 border-emerald-200", label;
  if (days < 0) { cls = "bg-red-50 text-red-700 border-red-200"; label = `${Math.abs(days)}d overdue`; }
  else if (days === 0) { cls = "bg-amber-50 text-amber-700 border-amber-200"; label = "Due today"; }
  else if (days <= 7) { cls = "bg-amber-50 text-amber-700 border-amber-200"; label = `${days}d left`; }
  else if (days > 270) { cls = "bg-zinc-100 text-zinc-500 border-zinc-200"; label = "Long-dated"; }
  else { label = `${days}d left`; }
  return (
    <span data-testid={testid} title={parsed.toLocaleDateString()}
      className={`inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded border whitespace-nowrap ${cls}`}>
      <CalendarClock className="h-3 w-3" /> {label}
    </span>
  );
}
